<ng-container class="flex flex-col"
  *ngIf="this.serviceLaneFacade.oemDashboardData$ | async as gmDashboardData; else dashboardLoading">
  <div *ngIf="gmDashboardData.error === null;">
    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;margin-top: 24px;"
      fxLayoutAlign="space-between center">
      <h2>Alerts</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(alertsUi)">
        <mat-icon>{{alertsUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!alertsUi.collapsed">
      <div class="alerts-container py-0 px-4" id="alertsContainer"
        *ngIf="gmDashboardData.dashboardJson && gmDashboardData.dashboardJson.dashboardAlerts">
        <ng-container *ngFor="let alert of gmDashboardData.dashboardJson.dashboardAlerts | orderBy: 'CampaignGroup'">
          <div class="flex flex-col alert-block" *ngIf="alert.CampaignGroup && alert.CampaignGroup !== 'Owner Center'">
            <div class="flex flex-row mb-1" fxLayoutAlign="start center">
              <div fxLayoutAlign="center center" [ngClass]="alert.SeverityCode === 'DANGER' ? 'danger' : 'warning'">
                <mat-icon class="text-base pb-1" fxLayoutAlign="center center">warning</mat-icon>
              </div>
              <span class="font-medium ml-2 text-base"> {{alert.CampaignGroup}} </span>
              <span *ngIf="alert.CampaignDate != null; else noCampaignDate" class="campaign-info"> · Campaign date is
                {{alert.CampaignDate | moment:
                'MMM DD, YYYY'}} </span>
              <ng-template #noCampaignDate>
                <span class="campaign-info"> · Unknown campaign date</span>
              </ng-template>
            </div>
            <div fxLayoutAlign="start start" class="pl-8">
              <span class="primary-bullet">·</span>
              <span *ngIf="alert.CampaignNumber != null; else noCampaignNumber">{{alert?.CampaignNumber}} -
                {{alert.CampaignDesc}}</span>
              <ng-template #noCampaignNumber>
                <span>{{alert.CampaignDesc}}</span>
              </ng-template>
            </div>
          </div>

          <div class="flex flex-col alert-block" *ngIf="alert.CampaignGroup === 'Owner Center'"
            id="ownerCenterContainer">
            <div *ngIf="getOwnerCenterStatus(alert.OtherInfo) as ownerCenterStatus">
              <div class="flex flex-row mb-1" fxLayoutAlign="start center">
                <div fxLayoutAlign="center center" [ngClass]="ownerCenterStatus.class">
                  <mat-icon class="text-base text-white" fxLayoutAlign="center center"
                    [ngClass]="ownerCenterStatus.class ==='danger' || 'warning'? 'pb-1': null">
                    {{ownerCenterStatus.icon}}</mat-icon>
                </div>
                <span class="font-medium ml-2 text-base"> {{alert.CampaignGroup}} </span>
                <span *ngIf="alert.CampaignDate != null; else noCampaignDate" class="campaign-info"> · Campaign date is
                  {{alert.CampaignDate | moment:
                  'MMM DD, YYYY'}} </span>
                <ng-template #noCampaignDate>
                  <span class="campaign-info"> · Unknown campaign date</span>
                </ng-template>
              </div>
              <div fxLayoutAlign="start start" class="pl-8">
                <span class="primary-bullet">·</span>
                <span> {{ownerCenterStatus.description}}</span>
              </div>
            </div>
          </div>

        </ng-container>
      </div>
    </ng-container>
    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
      fxLayoutAlign="space-between center">
      <h2>OnStar</h2>
      <button mat-icon-button style="margin-right:4px;" (click)="toggleCollapse(onStarUi)">
        <mat-icon>{{onStarUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!onStarUi.collapsed">
      <div class="alerts-container py-0 px-4 flex flex-col" id="onStarContainer"
        *ngIf="gmDashboardData.dashboardJson && gmDashboardData.dashboardJson.dashboardOnStarInfo">
        <div class="flex flex-col alert-block">
          <span class="font-medium text-base mb-2">Status</span>
          <div *ngFor="let dashboardOnStarInfo of gmDashboardData.dashboardJson.dashboardOnStarInfo">
            <div fxLayout="row wrap" class="pb-2 ml-2">
              <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
                <div fxLayoutAlign="center center" [ngClass]="dashboardOnStarInfo.OnStarStatus === 'true' ? 'pass' : 'danger'">
                  <mat-icon class="text-base" fxLayoutAlign="center center">
                    {{dashboardOnStarInfo.OnStarStatus === 'true' ? 'done' : 'close'}}</mat-icon>
                </div>
                <span class="ml-1 pt-0.5">Active</span>
              </div>
              <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
                <div fxLayoutAlign="center center" [ngClass]="dashboardOnStarInfo.OnStarDiag === 'true' ? 'pass' : 'danger'">
                  <mat-icon class="text-base" fxLayoutAlign="center center">
                    {{dashboardOnStarInfo.OnStarDiag === 'true' ? 'done' : 'close'}}</mat-icon>
                </div>
                <span class="ml-1 pt-0.5">Advanced Diagnostics Report</span>
              </div>
              <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
                <div fxLayoutAlign="center center" [ngClass]="dashboardOnStarInfo.DmnEnabled === 'true' ? 'pass' : 'danger'">
                  <mat-icon class="text-base" fxLayoutAlign="center center">
                    {{dashboardOnStarInfo.DmnEnabled === 'true' ? 'done' : 'close'}}</mat-icon>
                </div>
                <span class="ml-1 pt-0.5">Dealer Maintenance Notifications</span>
              </div>
              <div class="flex flex-row pb-1" fxFlex="50" fxLayoutAlign="start start">
                <div fxLayoutAlign="center center" [ngClass]="dashboardOnStarInfo.OwnerCenter === 'true' ? 'pass' : 'danger'">
                  <mat-icon class="text-base" fxLayoutAlign="center center">
                    {{dashboardOnStarInfo.OwnerCenter === 'true' ? 'done' : 'close'}}</mat-icon>
                </div>
                <span class="ml-1 pt-0.5">Owner Center</span>
              </div>
            </div>

            <mat-divider></mat-divider>

            <div class="mb-2 pt-2">
              <span class="font-medium text-base">Tires</span>
              <span *ngIf="dashboardOnStarInfo.TimeDataRead" class="campaign-info"> · As
                of
                {{dashboardOnStarInfo.TimeDataRead}} </span>
            </div>

            <div class="pb-2" fxLayout="row wrap" data-cy='all-tires-container'>
              <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start" data-cy='driver-front-tire'>
                <div fxLayoutAlign="center center" class="warning">
                  <mat-icon class="text-base pb-1" fxLayoutAlign="center center">warning</mat-icon>
                </div>
                <div class="flex flex-col ml-1 pt-0.5">
                  <div class="flex flex-row">
                    <span>Driver Front: </span>
                    <span *ngIf="dashboardOnStarInfo.LeftFrontTire; else noLeftFrontTireData">
                      {{dashboardOnStarInfo.LeftFrontTire}}</span>
                    <ng-template #noLeftFrontTireData>
                      <span class="ml-1">No data </span>
                    </ng-template>
                  </div>
                  <span *ngIf="dashboardOnStarInfo.FrontTireRec">
                    {{dashboardOnStarInfo.FrontTireRec}} recommended</span>
                </div>
              </div>
              <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start" data-cy='passenger-front-tire'>
                <div fxLayoutAlign="center center" class="warning">
                  <mat-icon class="text-base pb-1" fxLayoutAlign="center center">warning</mat-icon>
                </div>
                <div class="flex flex-col ml-1 pt-0.5">
                  <div class="flex flex-row">
                    <span>Passenger Front:</span>
                    <span *ngIf="dashboardOnStarInfo.RightFrontTire; else noRightFrontTireData">
                      {{dashboardOnStarInfo.RightFrontTire}}</span>
                    <ng-template #noRightFrontTireData>
                      <span class="ml-1">No data </span>
                    </ng-template>
                  </div>
                  <span *ngIf="dashboardOnStarInfo.FrontTireRec">
                    {{dashboardOnStarInfo.FrontTireRec}} recommended</span>
                </div>
              </div>
              <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start" data-cy='driver-rear-tire'>
                <div fxLayoutAlign="center center" class="warning">
                  <mat-icon class="text-base pb-1" fxLayoutAlign="center center">warning</mat-icon>
                </div>
                <div class="flex flex-col ml-1 pt-0.5">
                  <div class="flex flex-row">
                    <span>Driver Rear:</span>
                    <span *ngIf="dashboardOnStarInfo.LeftBackTire; else noLeftBackTireData">
                      {{dashboardOnStarInfo.LeftBackTire}}</span>
                    <ng-template #noLeftBackTireData>
                      <span class="ml-1">No data </span>
                    </ng-template>
                  </div>
                  <span *ngIf="dashboardOnStarInfo.BackTireRec">
                    {{dashboardOnStarInfo.BackTireRec}} recommended</span>
                </div>
              </div>
              <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start" data-cy='passenger-rear-tire'>
                <div fxLayoutAlign="center center" class="warning">
                  <mat-icon class="text-base pb-1" fxLayoutAlign="center center">warning</mat-icon>
                </div>
                <div class="flex flex-col ml-1 pt-0.5">
                  <div class="flex flex-row">
                    <span>Passenger Rear:</span>
                    <span *ngIf="dashboardOnStarInfo.RightBackTire; else noRightBackTireData">
                      {{dashboardOnStarInfo.RightBackTire}}</span>
                    <ng-template #noRightBackTireData>
                      <span class="ml-1">No data </span>
                    </ng-template>
                  </div>
                  <span *ngIf="dashboardOnStarInfo.BackTireRec">
                    {{dashboardOnStarInfo.BackTireRec}} recommended</span>
                </div>
              </div>
            </div>

            <mat-divider></mat-divider>

            <span class="font-medium text-base mb-2 pt-2">XM Radio Information</span>

            <div class="pb-2" fxLayout="row wrap;" data-cy='xm-radio-info'>
              <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
                <div fxLayoutAlign="center center" [ngClass]="dashboardOnStarInfo.XmEquipped === 'true' ? 'pass' : 'danger'">
                  <mat-icon class="text-base" fxLayoutAlign="center center">
                    {{dashboardOnStarInfo.XmEquipped === 'true' ? 'done' : 'close'}}</mat-icon>
                </div>
                <span class="ml-1 pt-0.5">Equipped</span>
              </div>
              <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
                <div fxLayoutAlign="center center" [ngClass]="dashboardOnStarInfo.XmStatus === 'true' ? 'pass' : 'danger'">
                  <mat-icon class="text-base" fxLayoutAlign="center center">
                    {{dashboardOnStarInfo.XmStatus === 'true' ? 'done' : 'close'}}</mat-icon>
                </div>
                <span class="ml-1 pt-0.5">Active</span>
              </div>
            </div>

            <mat-divider></mat-divider>

            <span class="font-medium text-base mb-2 pt-2">Other</span>

            <div fxLayout="row wrap">
              <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
                <mat-icon class="text-2xl" xLayoutAlign="center center">info</mat-icon>
                <div class="ml-1 pt-0.5">
                  <span>Odometer Reading:</span>
                  <span *ngIf="dashboardOnStarInfo.Odometer; else noOdometer">
                    {{dashboardOnStarInfo.Odometer}}</span>
                  <ng-template #noOdometer>
                    <span class="ml-1">No data </span>
                  </ng-template>
                </div>
              </div>

              <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
                <mat-icon class="text-2xl" xLayoutAlign="center center">info</mat-icon>
                <div class="ml-1 pt-0.5">
                  <span>Oil Life:</span>
                  <span *ngIf="dashboardOnStarInfo.OilLifePct; else noOilLifePct">
                    {{dashboardOnStarInfo.OilLifePct}}%</span>
                  <ng-template #noOilLifePct>
                    <span class="ml-1">No data </span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
      fxLayoutAlign="space-between center">
      <h2>Service Contracts/Warranties</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(serviceContractWarrantiesUi)">
        <mat-icon>{{serviceContractWarrantiesUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!serviceContractWarrantiesUi.collapsed">
      <div class="py-0 px-4" id="claimsHistoryContainer"
        *ngIf="gmDashboardData.dashboardJson && gmDashboardData.dashboardJson.dashboardServiceContracts">
        <h3>Service Contracts</h3>
        <div *ngFor="let serviceContract of gmDashboardData.dashboardJson.dashboardServiceContracts"
          class="flex flex-col w-full result-container" data-cy='service-contracts'>
          <div fxLayoutAlign="space-between center" class="result-header-container">
            <div class="flex flex-col">
              <div class="flex flex-row" fxLayoutAlign="start center">
                <h3>{{serviceContract.PlanDesc}} (Policy No. {{serviceContract.PolicyNumber}})</h3>
              </div>
              <span class="mat-small">{{serviceContract.OwnerName}}</span>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="flex flex-col result-content-container">
            <div class="flex flex-col">
              <div class="flex flex-col w-full">
                <div class="flex flex-row pb-5" fxLayoutAlign="start start">
                  <div class="flex flex-col">
                    <div fxLayoutAlign="start center">
                      <span class="primary-bullet">·</span>
                      <span>Deductible amount is {{serviceContract.DeductibleAmt | currency}}</span>
                    </div>
                    <div fxLayoutAlign="start center">
                      <span class="primary-bullet">·</span>
                      <span>Rental allowance is {{serviceContract.RentalAmt | currency}}</span>
                    </div>
                    <div fxLayoutAlign="start center">
                      <span class="primary-bullet">·</span>
                      <span>Effective on {{serviceContract.EffectiveDate | moment: 'MMM DD, YYYY'}},
                        {{serviceContract.EffectiveOdo | number | unitOfMeasure | async}}</span>
                    </div>
                    <div fxLayoutAlign="start center">
                      <span class="primary-bullet">·</span>
                      <span>Expires on {{serviceContract.ExpirationDate | moment: 'MMM DD, YYYY'}},
                        {{serviceContract.ExpirationOdo | number | unitOfMeasure | async}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h3>Factory Warranties</h3>
        <div *ngIf="gmDashboardData.dashboardJson && gmDashboardData.dashboardJson.dashboardVehicleWarranty">
          <div
            *ngFor="let vehicleWarranty of gmDashboardData.dashboardJson.dashboardVehicleWarranty | orderBy: ['WarrOrderSeq']"
            class="flex flex-col w-full result-container" data-cy="factory-warranties">
            <div fxLayoutAlign="space-between center" class="result-header-container">
              <div class="flex flex-col">
                <div class="flex flex-row" fxLayoutAlign="start center">
                  <h3>{{vehicleWarranty.PlanDesc}}</h3>
                </div>
                <div class="flex flex-row" fxLayoutAlign="start center">
                  <span class="mat-small" *ngIf="vehicleWarranty.WarrStatus === 'Expired'; else notExpired">
                    {{vehicleWarranty.WarrStatus}} · {{vehicleWarranty.ExpirationDate | moment: 'MMM DD, YYYY'}},
                    {{vehicleWarranty.ExpirationOdo | number | unitOfMeasure | async}}
                  </span>
                  <ng-template #notExpired>
                    <span class="mat-small">
                      {{vehicleWarranty.WarrStatus}}, {{vehicleWarranty.EffectiveDate | moment: 'MMM DD, YYYY'}},
                      {{vehicleWarranty.EffectiveOdo | number | unitOfMeasure | async}} · Expires on
                      {{vehicleWarranty.ExpirationDate | moment: 'MMM DD, YYYY'}},
                      {{vehicleWarranty.ExpirationOdo | number | unitOfMeasure | async}}</span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
      fxLayoutAlign="space-between center">
      <h2>Claims History</h2>
      <button mat-icon-button style="margin-right:4px;" (click)="toggleCollapse(claimsHistoryUi)">
        <mat-icon>{{claimsHistoryUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!claimsHistoryUi.collapsed">
      <div class="py-0 px-4" id="claimsHistoryContainer"
        *ngIf="gmDashboardData.dashboardJson && gmDashboardData.dashboardJson.dashboardWarrantyClaimsHistoryIvh">
        <div
          *ngFor="let ro of gmDashboardData.dashboardJson.dashboardWarrantyClaimsHistoryIvh | orderBy: ['-ServiceDate']"
          class="flex flex-col w-full result-container" data-cy='warranty-claim-history'>
          <div fxLayoutAlign="space-between center" class="result-header-container">
            <div class="flex flex-col">
              <div class="flex flex-row" fxLayoutAlign="start center">
                <h3>Work Order {{ro.RepairOrder ? ro.RepairOrder : ro.RoNumber}}</h3>
              </div>
              <span class="mat-small">
                {{ro.RoCloseDate | moment: 'MMM DD, YYYY'}} · {{ro.Odometer | number | unitOfMeasure | async}}
              </span>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="flex flex-col result-content-container">
            <div class="flex flex-col">
              <div class="flex flex-col w-full">
                <div class="flex flex-row pb-5" fxLayoutAlign="start start"
                  *ngFor="let case of ro.LabourOps;let i = index;" data-cy='labour-ops'>
                  <div class="test-container" fxLayoutAlign="center center">
                    <span class="test-content">{{i+1}}</span>
                  </div>
                  <div class="flex flex-col">
                    <div fxLayoutAlign="start start">
                      <a class="mat-body-2">
                        {{case.LabourOp ? case.LabourOp + ' - ' : case.DmsLabourOp ? case.DmsLabourOp + ' - ' :
                        ''}}{{case.LabourDescription ? case.LabourDescription : case.DmsLabourOpDesc}}
                      </a>
                    </div>
                    <div class="flex flex-col">
                      <div class="flex flex-col text-grey-700">
                        <div fxLayoutAlign="start center">
                          <span class="primary-bullet">·</span>
                          <span class="font-medium">{{case.ServiceType ? case.ServiceType : case.JobType}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
      fxLayoutAlign="space-between center">
      <h2>RO History</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(roHistoryUi)">
        <mat-icon>{{roHistoryUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!roHistoryUi.collapsed">
      <div class="py-0 px-4" id="roHistoryContainer"
        *ngIf="gmDashboardData.dashboardJson && gmDashboardData.dashboardJson.dashboardWarrantyClaimsHistoryDmsDetails">
        <div
          *ngFor="let ro of gmDashboardData.dashboardJson.dashboardWarrantyClaimsHistoryDmsDetails | orderBy: ['RoCloseDate']"
          class="result-container flex flex-col w-full" data-cy='warranty-claim-history-dms'>
          <div fxLayoutAlign="space-between center" class="result-header-container">
            <div class="flex flex-col">
              <div class="flex flex-row" fxLayoutAlign="start center">
                <h3>Work Order {{ro.RepairOrder ? ro.RepairOrder : ro.RoNumber}}</h3>
              </div>
              <span class="mat-small" *ngIf="ro.ServiceDate; else rcCloseDate">
                {{ro.ServiceDate | moment: 'MMM DD, YYYY'}} · {{ro.Odometer | number | unitOfMeasure | async}}
              </span>
              <ng-template #rcCloseDate>
                <span class="mat-small">
                  {{ro.RoCloseDate | moment: 'MMM DD, YYYY'}} · {{ro.Odometer | number | unitOfMeasure | async}}
                </span>
              </ng-template>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="flex flex-col result-content-container">
            <div class="flex flex-col">
              <div class="flex flex-col w-full">
                <div class="flex flex-row pb-5" fxLayoutAlign="start start"
                  *ngFor="let case of ro.LabourOps | orderBy: ['JobType'];let i = index;" data-cy='labour-ops'>
                  <div class="test-container" fxLayoutAlign="center center">
                    <span class="test-content">{{i+1}}</span>
                  </div>
                  <div class="flex flex-col">
                    <div fxLayoutAlign="start start">
                      <a class="mat-body-2">
                        {{case.LabourOp ? case.LabourOp + ' - ' : case.DmsLabourOp ? case.DmsLabourOp + ' - ' :
                        ''}}{{case.LabourDescription ? case.LabourDescription : case.DmsLabourOpDesc}}
                      </a>
                    </div>
                    <div class="flex flex-col">
                      <div class="flex flex-col text-grey-700">
                        <div fxLayoutAlign="start center">
                          <span class="primary-bullet">·</span>
                          <span class="font-medium">{{case.ServiceType ? case.ServiceType : case.JobType}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- <ng-template #dashboardError>
    <div fxLayoutAlign="center center" style="padding: 24px 0;">
      <mat-error>There was an error retrieving dashboard data from the GM integration point. The last check for data was
        performed at
        {{gmDashboardData.latestCheckForData | moment:
        'hh:mm a, MMM DD, YYYY'}} </mat-error>
    </div>
  </ng-template> -->
  <ng-template #noDashboard>
    <div fxLayoutAlign="center center" class="py-6 px-0">
      <span>No dashboard data was returned from the GM integration point. The last check for data was performed at
        {{gmDashboardData.latestCheckForData | moment:
        'hh:mm a, MMM DD, YYYY'}} </span>
    </div>
  </ng-template>
</ng-container>


<ng-template #dashboardLoading>
  <ng-container class="flex flex-col">
    <div
      style="width:100%;position:sticky;top:66px;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;">
      <h2>Alerts</h2>
    </div>
    <div class="alerts-container py-0 px-4" id="alertsContainer">
      <div class="alert-block flex flex-col">
        <div class="flex flex-row mb-1" fxLayoutAlign="start center">
          <!-- <div fxLayoutAlign="center center">
            <div style="height:24px;width:24px;margin:6px 0 6px 8px;border-radius:8px;" class="animated-background"></div>
          </div> -->
          <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
          </div>
          <span class="animated-background h-4 w-1/3 my-1.5 mr-0 ml-2 rounded"></span>



        </div>
        <div fxLayoutAlign="start start" class="pl-8">
          <span class="animated-background h-4 w-1/5 my-1.5 mr-0 ml-2 rounded"></span>
        </div>
      </div>
    </div>

    <div
      style="width:100%;position:sticky;top:66px;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;">
      <h2>OnStar</h2>
    </div>
    <div class="flex flex-col alerts-container py-0 px-4" id="onStarContainer">
      <div class="flex flex-col alert-block">
        <span class="font-medium text-base mb-2">Status</span>

        <div fxLayout="row wrap">
          <div fxFlex="50" class="flex flex-row mb-1" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
        </div>
      </div>

      <div class="flex flex-col" class="alert-block">

        <div class="mb-2">
          <span class="animated-background h-4 w-1/3 my-1.5 mr-0 ml-1 rounded"></span>
          <span class="font-medium text-base mb-2">Tires</span>
        </div>

        <div fxLayout="row wrap">

          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>

            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col alert-block">
        <span class="font-medium text-base mb-2">XM Radio Information</span>

        <div fxLayout="row wrap">
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
        </div>
      </div>

      <div class="alert-block flex flex-col">
        <span class="font-medium text-base mb-2">Other</span>

        <div fxLayout="row wrap">
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>

          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
        </div>
      </div>
    </div>

    <div
      style="width:100%;position:sticky;top:66px;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;">
      <h2>Claims History</h2>
    </div>

    <div class="py-0 px-4" id="claimsHistoryContainer">
      <div class="flex flex-col w-full result-container">
        <div fxLayoutAlign="space-between center" class="result-header-container">
          <div class="flex flex-col w-full">
            <div class="flex flex-row w-full" fxLayoutAlign="start center">
              <span class="animated-background h-5 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
            </div>
            <span class="animated-background h-4 w-1/3 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="result-content-container flex-col">
          <div class="flex flex-col">
            <div class="flex flex-col w-full">
              <div class="flex flex-row pb-5" fxLayoutAlign="start start">
                <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl"></div>
                <div class="flex flex-col">
                  <div fxLayoutAlign="start start">
                    <span class="animated-background h-4 w-4/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
                  </div>
                  <div class="flex flex-col">
                    <div class="flex flex-col text-grey-700">
                      <div fxLayoutAlign="start center">
                        <div class="animated-background h-1 w-1 my-1.5 mr-0 ml-2 rounded-sm"></div>
                        <span class="animated-background h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>